import { render, staticRenderFns } from "./loggers-list.vue?vue&type=template&id=25d8086e&"
import script from "./loggers-list.vue?vue&type=script&lang=js&"
export * from "./loggers-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports